import { AutomationState } from "../types";

const state: AutomationState = {
  threshold: 0,
  thresholdFacial: 0,
  enabled: false,
  enabledReview: false,
  retentionDays: 0,
};

export default state;
